import React from 'react';
import { ToolTipContainer, ToolTipTitle } from './styles';
import { TableBody, TableColumn, TableRow, TableUnit } from '../Table/styles';
import { capitalizeFirstLetters } from '../../utils/hooks/text-formatter';
import { Oval } from '../../pages/players/styles';
export default  ({ section, tooltipRef }: { section?: any, tooltipRef?: any }) => {

  return (
    <>
    <ToolTipContainer ref={tooltipRef}>
      <ToolTipTitle>{section[2]}</ToolTipTitle>
      <TableUnit color={'#F7F8FA'} fontSize={'10px'}>
        <TableBody>
            {Object.keys(section[0].zones).map((zone, index) =>
            <TableRow key={index}>
            <TableColumn border={'none'} textAlign={'left'} height={'24px'}>
              <Oval size={'8'} color={zone} margin={'0px 8px'} />
              {capitalizeFirstLetters(zone,' ')}
            </TableColumn>
            <TableColumn border={'none'} height={'24px'}>
              {section[0].zones[zone][section[1]]}
            </TableColumn>
          </TableRow>
            )}
        </TableBody>
      </TableUnit>
    </ToolTipContainer>
    </>
  )
};
